import { FaImage } from "react-icons/fa";

export default function ChatImageEmbedding({ url }) {
    let directUrl = url;

    if (url.includes("imgur.com") && !url.endsWith(".jpg")) {
        directUrl = url.replace("imgur.com/", "i.imgur.com/") + ".jpg";
    }

    return (
        <div className="my-4 px-4 w-full flex justify-center">
            <div className="w-full max-w-2xl flex items-start">
                <div className="rounded-full h-8 w-8 bg-[#140D4F] text-white flex items-center justify-center font-semibold text-slate-50 shrink-0">
                    <FaImage />
                </div>
                <div className="p-1 ml-2 min-w-0 flex-1 text-left">
                    <p className="font-semibold text-[#140D4F]">Image</p>
                    <img
                        src={directUrl}
                        alt="Embedded content"
                        className="max-w-full max-h-[500px] rounded-lg shadow-lg cursor-pointer mx-auto"
                        onClick={() => window.open(directUrl, '_blank')}
                        title="Click to open in new tab"
                    />
                </div>
            </div>
        </div>
    );
}
